export default __webpack_public_path__ + "locales/zh-CN/VersionHistory.json?hash=7fcfb33ce6e696808155b4c05816aef3";